import { make } from 'redux-chill';

import type { SenderInfoUT } from '../types';

const setDeliverySenderInfoUt = make('[delivery] set senderUt info')
  .stage((info: SenderInfoUT) => ({ info }))
  .stage('reset');

export { setDeliverySenderInfoUt };
